var map = {
	"./buy_normal_cn.png": 33150,
	"./buy_normal_en.png": 52584,
	"./buy_normal_id.png": 47974,
	"./buy_normal_ko.png": 92095,
	"./buy_normal_ph.png": 29805,
	"./buy_normal_th.png": 79289,
	"./buy_normal_zh.png": 22587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64912;